<small *ngIf="helptext" class="{{class}} form-text text-muted">
    {{helptext}}
</small>
